import { ENV } from "@/enum/system";
import { useDevicePerformance } from "@/hooks/useDevicePerformance";

import { BaseSDK, SDKConfig } from "./base";
import { SDKName } from "./types";

interface HotjarConfig extends SDKConfig {
  siteId: number;
  sv: number;
}

export class HotjarSDK extends BaseSDK {
  constructor(config: HotjarConfig) {
    super(SDKName.HotjarSDK, config);
  }

  async initialize(): Promise<void> {
    const { isHighEnd } = useDevicePerformance();
    if (!isHighEnd) {
      return;
    }

    const config = this.config as HotjarConfig;

    // Create Hotjar script
    const script = document.createElement("script");
    script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${config.siteId},hjsv:${config.sv}};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    document.head.appendChild(script);
  }

  reportEvent(event: string, data: Record<string, unknown>): string {
    //处理事件上报
    return "";
  }
}
